import { useState } from "react";
import { watchMoods } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function WatchGuide() {
  const [activeKey, setActiveKey] = useState(watchMoods[0].key);
  const active = watchMoods.find((m) => m.key === activeKey) ?? watchMoods[0];

  return (
    <section id="guide" className="bg-background-50 px-6 lg:px-10 py-14 md:py-20 scroll-mt-24">
      <SectionHeading
        index="03"
        label="What To Watch"
        title="有什么好看的 · 推荐指南"
        desc="不知道该看什么的时候，先选自己当下的状态，再从对应的清单里挑一条开始。"
      />

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-[300px_1fr] gap-6">
        <div className="flex flex-col gap-2">
          {watchMoods.map((mood) => (
            <button
              key={mood.key}
              type="button"
              onClick={() => setActiveKey(mood.key)}
              className={`text-left px-5 py-4 rounded-lg border transition-colors cursor-pointer ${
                activeKey === mood.key
                  ? "bg-foreground-950 border-foreground-950 text-background-50"
                  : "bg-background-100 border-background-200 hover:border-foreground-400"
              }`}
            >
              <span className="flex items-center justify-between">
                <span className="text-sm font-medium">{mood.label}</span>
                <i
                  className={
                    activeKey === mood.key
                      ? "ri-arrow-right-line text-accent-400"
                      : "ri-arrow-right-line text-foreground-400"
                  }
                ></i>
              </span>
              <span
                className={`mt-1 block text-xs ${
                  activeKey === mood.key ? "text-background-300" : "text-foreground-500"
                }`}
              >
                {mood.note}
              </span>
            </button>
          ))}
        </div>

        <div className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-8">
          <div className="flex items-center gap-3 pb-5 border-b border-background-200">
            <span className="w-11 h-11 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center">
              <i className="ri-compass-3-line text-[22px]"></i>
            </span>
            <div>
              <h5 className="font-heading font-bold text-lg text-foreground-950">
                {active.label}
              </h5>
              <p className="text-xs text-foreground-500 mt-0.5">{active.note}</p>
            </div>
          </div>

          <div className="mt-2 divide-y divide-background-200">
            {active.items.map((item, i) => (
              <a
                key={item.title}
                href="#hot"
                className="flex items-start gap-4 py-4 cursor-pointer group"
              >
                <span className="font-label text-lg text-primary-500 w-7 shrink-0 pt-0.5">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="flex-1">
                  <span className="block text-[15px] font-medium text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </span>
                  <span className="mt-1 block text-sm text-foreground-600">
                    {item.note}
                  </span>
                </span>
              </a>
            ))}
          </div>

          <div className="mt-4 pt-5 border-t border-background-200 flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-lightbulb-line text-accent-600"></i>
            选不出也没关系，从第一条开始，通常都不会错。
          </div>
        </div>
      </div>
    </section>
  );
}